import { render, staticRenderFns } from "./InviteToListMenu.vue?vue&type=template&id=7f56c528&scoped=true&"
import script from "./InviteToListMenu.vue?vue&type=script&lang=js&"
export * from "./InviteToListMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f56c528",
  null
  
)

export default component.exports